module.exports = __webpack_public_path__ + "img/empty-growth-plan.156a8e02.svg";